export const ICON_SIZE = 24;
export const DEFAULT_COLOR = '#000000';
